import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLocations } from 'modules/locations/store/actions';
import useLocations from './use-locations';

export const useFetchLocation = () => {
  const dispatch = useDispatch();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { isLoading, isLoaded, locations, tournamentId: tournamentIdFromLocations } = useLocations();

  useEffect(() => {
    if (tournamentId && tournamentId !== tournamentIdFromLocations) {
      dispatch(fetchLocations({ tournamentId }));
    }
  }, [dispatch, tournamentId, tournamentIdFromLocations]);

  return {
    isLoading,
    isLoaded,
    locations,
  };
};
